"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var chapter_1 = __importDefault(require("./chapter"));
var isEmptyString = function (value) {
    return value === '';
};
var VideoContent = /** @class */ (function () {
    // TypeScript prop
    function VideoContent(id, videoUrl, layout, title, authors, references, chapters) {
        if (layout === void 0) { layout = VideoContent.defaultLayout; }
        if (title === void 0) { title = ''; }
        if (authors === void 0) { authors = ''; }
        if (references === void 0) { references = ''; }
        this.id = id;
        this.videoUrl = videoUrl;
        this.layout = layout;
        this.title = title;
        this.authors = authors;
        this.references = references;
        this.chapters = chapters;
    }
    Object.defineProperty(VideoContent.prototype, "chapters", {
        /**
         * @see {@link https://javascript.info/property-accessors#smarter-getters-setters}
         * @see {@link https://www.typescriptlang.org/docs/handbook/classes.html#accessors}
         */
        get: function () {
            return this._chapters;
        },
        set: function (value) {
            // Check if is Chapter type, if true assign it to _chapters and return
            if (value instanceof chapter_1.default) {
                this._chapters = value;
                // TODO - TypeScript: What should be returned?
                return;
            }
            // No need to perform
            // if (!Array.isArray(value) && typeof value !== 'object' && typeof value !== 'string') {
            //     throw new TypeError("chapters must be an 'array', an object or a 'string'");
            // }
            if (typeof value === 'string') {
                value = JSON.parse(value);
            }
            var validChapters = [];
            var pushChapter = function (oneValue) {
                var title = oneValue.title;
                var seconds = oneValue.seconds;
                var chapter = new chapter_1.default(title, seconds);
                validChapters.push(chapter);
            };
            // if(!Array.isArray(value) && typeof value === 'object') {
            //     let chapter = new Chapter(value.title, value.seconds);
            //     validChapters.push(chapter);
            // } else if (Array.isArray(value)) {
            if (value instanceof Array) {
                value.forEach(pushChapter);
            }
            else {
                pushChapter(value);
            }
            this._chapters = validChapters;
        },
        enumerable: false,
        configurable: true
    });
    VideoContent.isLayout = function (layout) {
        return VideoContent.layouts.includes(layout);
    };
    VideoContent.isHorizontalLayout = function (layout) {
        return layout === VideoContent.horizontalLayout;
    };
    VideoContent.isVerticalLayout = function (layout) {
        return layout === VideoContent.verticalLayout;
    };
    VideoContent.prototype.hasHorizontalLayout = function () {
        return VideoContent.isHorizontalLayout(this.layout);
    };
    VideoContent.prototype.hasVerticalLayout = function () {
        return VideoContent.isVerticalLayout(this.layout);
    };
    VideoContent.prototype.isTitleEmpty = function () {
        return isEmptyString(this.title);
    };
    VideoContent.prototype.isAuthorsEmpty = function () {
        return isEmptyString(this.authors);
    };
    VideoContent.prototype.isReferencesEmpty = function () {
        return isEmptyString(this.references);
    };
    VideoContent.prototype.isAdditionalContentsEmpty = function () {
        return this.isTitleEmpty()
            && this.isAuthorsEmpty()
            && this.isReferencesEmpty();
    };
    VideoContent.horizontalLayout = 'horizontal';
    VideoContent.verticalLayout = 'vertical';
    VideoContent.layouts = [VideoContent.horizontalLayout, VideoContent.verticalLayout];
    VideoContent.defaultLayout = VideoContent.horizontalLayout;
    return VideoContent;
}());
exports.default = VideoContent;
